import React from 'react';
import './Label.scss';

export function getLabelClass(labelType) {
  switch (labelType) {
    case 'regular':
      return 'prequal-web-cancel-fomo-regular';
    case 'bold':
      return 'prequal-web-cancel-fomo-bold';
    case 'semi-bold':
      return 'prequal-web-cancel-fomo-semibold';
    case 'medium':
      return 'prequal-web-cancel-fomo-medium';
    default:
      return 'prequal-web-cancel-fomo-regular';
  }
}

function Label({content, labelType, dataTestId}) {
  return (
    <div className='fomo-label-container'>
      <span data-testid={dataTestId} className={getLabelClass(labelType)}>
        {content}
      </span>
    </div>
  );
}
export default Label;
